import { useState, useEffect } from 'react';
import { Tabs, Space, Form, Spin, Button } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { ViewAgenda } from '@mui/icons-material';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeMourabahaDto } from '../../../../../Models/DemandeMourabahaDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import { useNavigate } from 'react-router-dom';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import { useAgence } from '../../../../../AgenceContext';
import { PrintTabamountMourabaha } from '../../../../../utilitaires/PrintTabamortMourabaha';

const PropositionMourabaha = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [sbmit, setSbmit] = useState('');
  const [data, setData] = useState<DemandeMourabahaDto[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState<any[]>([]);
  const navigate = useNavigate();
  const Branch = useAgence();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const initialiazeButton = () => {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  };

  // const SetStart = () => {
  //   setSbmit('add');
  //   setAjoutActif(true);
  //   setEnregActve(false);
  //   setAnnulActive(false);
  //   setConsulActive(true);
  //   form.resetFields();
  //   setGarantiesTableau([]);
  //   setdatatabamort([]);
  // };

  // const SetEndStart = () => {
  //   SetStartForm(true);
  // };

  const loadFinancement = () => {
    localStorage.clear();
    setPageLoad(false);
    setLoading(true);
    setData([]);

    let searchClientComptes: ParamsPicklist = {
      CodeAgence: user.codage,
      Table: 'DEMAND_FINMOURABAHA',
      Colonne1: 'EtapeActuelle',
      Colonne2: '',
      Init: 'PROPOSITION',
      Colagence: 'CODAGE',
      Choix: 34,
    };

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchClientComptes)),
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length === 0) {
              SweetAlert.fire({ title: 'Aucune demande Mourabaha en cours', icon: 'warning' });
              setData([]);
            } else {
              const newData: DemandeMourabahaDto[] = datas.map((data: any, indice: number) => ({
                ...data,
                key: indice,
                NumeroDemande: data.NumeroDemande,
                Numcli: data.NUMCLI,
                NOMCLI: data.NOMCLI,
                DateDemande: data.DateDemande ? new Date(data.DateDemande.substring(0, 10)).toLocaleDateString('fr') : '',
                MontantDemande: data.CoutAchatDemande,
              }));
              setData(newData);
            }
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
      });
  };

  if (pageLoad) {
    loadFinancement();
  }

  const columns = [
    {
      title: 'Date Demande',
      dataIndex: 'DateDemande',
    },
    {
      title: 'N° Demande',
      dataIndex: 'NumeroDemande',
    },
    {
      title: 'N° Client',
      dataIndex: 'Numcli',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
    {
      title: 'Montant demandé',
      dataIndex: 'CoutAchatDemande',
      render: (value: any) => formatNumber(value),
    },
  ];

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + '');
    });
    SweetAlert.fire({
      title: 'Veuillez remplir tous les champs obligatoires',
      text: errors.toString().replaceAll(',', ' - '),
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  };

  const onFinish = (values: any) => {
    const proposition: DemandeMourabahaDto = {
      CODAGE: user.codage,
      DatePremEch: formatDate(values.DatePremEch),
      Numcli: values.NUMCLI,
      NOMCLI: values.lib_NUMCLI,
      Documents: values.Document || [],
      ...values,
    } as any;

    SweetAlert.fire({
      title:
        'Voulez-vous enregistrer la proposition Mourabaha du client : ' +
        values.lib_NUMCLI +
        ' pour le demande ' +
        values.NumeroDemande +
        ' ? ',
      showCancelButton: true,
      color: 'green',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'green',
      cancelButtonColor: 'darkred',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
    }).then((res) => {
      if (res.isConfirmed) {
        try {
          setLoading(true);
          setIsSubmit(true);
          proposition.UtilPropose = user.coduti;
          proposition.CodeUti = user.coduti;
        //   proposition.DatePropose = user.datjour;

          let data = Crypter.encrypt(JSON.stringify(proposition));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.ProposeMourabaha,
            headers: {
              Authorization: authHeader(),
              'Content-Type': 'application/json',
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setGarantiesTableau([]);
                  setdatatabamort([]);
                  setImpActive(false);
                  loadFinancement();
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                } else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: error, icon: 'error' });
            });
        } catch (error) {
          SweetAlert.fire({ title: 'Error occurred while saving proposition', icon: 'error' });
        }
      }
    });
  };

  const consultTypeMourabaha = () => {
    if (form.getFieldValue('CodeMourabaha') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Mourabaha ', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeMourabaha'));
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsMourabaha,
          headers: {
            CypherCodeMourabaha: data,
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                  // const params = res.Result.Table1[0];
                  form.setFieldValue('CodeFrais', res.Result.Table3?.map((x: any) => x.CODOPE) || []);
                  // form.setFieldValue("MontantFrais", params.MontantFrais);
              } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  };

  const onSelectChange = (newSelectedRowKeys: any) => {
    const requestedIndex = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    if (requestedIndex !== undefined && data[requestedIndex]) {
      form.setFieldsValue(data[requestedIndex]);
      handleDemandeMourabaha(data[requestedIndex].NumeroDemande);
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined /> Proposition
        </span>
      ),
      children: <Tab1 form={form} consultTypeMourabaha={consultTypeMourabaha} />,
    },
    
    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined /> Documents
        </span>
      ),
      children: <Tab5 form={form} />,
    },

    {
      key: '3',
      label: (
        <span id='Tab'>
          <ContactsOutlined /> Garanties
        </span>
      ),
      children: <Tab2 form={form} garantiesTableau={garantiesTableau} />,
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined /> Frais de Gestion
        </span>
      ),
      children: <Tab3 form={form} />,
    },
    {
      key: '5',
      label: (
        <span id='Tab'>
          <ViewAgenda /> Tableau
        </span>
      ),
      children: <Tab4 form={form} data={datatabamort} />,
    },
  ];

  function handleDemandeMourabaha(numeroDemande?: string) {
    const demande = numeroDemande ?? form.getFieldValue('NumeroDemande');
    // alert(demande)
    localStorage.setItem(Data.LocalVariable.reset, '1');
    let dataCrypt = Crypter.encrypt(demande);
    let dataction = Crypter.encrypt('READ_DEMANDE');

    if (dataCrypt.length != 0) {
      initialiazeButton();
      setLoading(true);
      form.resetFields();
      form.setFieldValue('NumeroDemande', demande);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFiancementMourabaha,
        headers: {
          CypherNumeroDemandeMourabaha: dataCrypt,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table1[0]);
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
              form.setFieldValue('lib_NUMCLI', res.Result.Table1[0].NOMCLI);
              form.setFieldValue('MontantDemande', res.Result.Table1[0].CoutAchatDemande);

              form.setFieldValue('CoutAchatPropose', res.Result.Table1[0].CoutAchatDemande);
              form.setFieldValue('MargeMourabahaProp', res.Result.Table1[0].MargeMourabahaDem);


              const garantiesRetournees: DataTypeTable[] = [];
              if (res.Result.Table2) {
                res.Result.Table2.map((item: any) => {
                  garantiesRetournees.push({ ...item, valCouvert: item.MontantCouvert });
                });
                form.setFieldValue('montantGarantieCouvert', garantiesRetournees.reduce((sum, g) => sum + (g.valCouvert || 0), 0));
              }

              const newData: any[] = [];
              if (res.Result.Table3) {
                res.Result.Table3.map((item: any) => {
                  newData.push({
                    ...item,
                    CapitalInitial: formatNumber(item.CapitalInitial),
                    Armotissement: formatNumber(item.Armotissement),
                    PartMargeHT: formatNumber(item.PartMargeHT),
                    PartTVA: formatNumber(item.PartTVA),
                    Annuite: formatNumber(item.Annuite),
                    CapitalRestant: formatNumber(item.CapitalRestant),
                    SoldeRestantTTC: formatNumber(item.SoldeRestantTTC),
                    DateEcheance: item.DateEcheance ? new Date(item.DateEcheance.substring(0, 10)).toLocaleDateString('fr') : '',
                  });
                });
              }

              setGarantiesTableau(garantiesRetournees);
              setdatatabamort(newData);
              consultTypeMourabaha();
              initialiazeButton();
              cunsultButton();
              setEnregActve(false);
              setImpActive(false);
            } else {
              localStorage.removeItem(Data.LocalVariable.reset);
              SweetAlert.fire({ title: res.Message, icon: 'warning' });
              setSelectedRowKeys([]);
            }
          }
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset);
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
          setSelectedRowKeys([]);
        });
    }
  }

  function cunsultButton() {
    setAnnulActive(false);
    setModifActve(false);
  }

  function handleApercu() {
    const values = form.getFieldsValue(true);
    PrintTabamountMourabaha(
      {
        frais: values.FraisService ?? 0,
        NUMCLI: values.NUMCLI ?? values.Numcli ?? '',
        NOMCLI: values.lib_NUMCLI ?? values.NOMCLI ?? '',
        NumeroDemande: values.NumeroDemande ?? '',
        CoutAchat: values.CoutAchatPropose,
        Marge: values.MargeMourabahaProp,
        NombreEch: values.NombreEch,
        DatePremEch: formatDate(values.DatePremEch),
      },
      {
        codAgce2: user.codage ?? '',
        libelle: Branch.agence?.LIBELLE ?? '',
        banque: Branch.agence?.BANQUE ?? '',
        teleph: Branch.agence?.TELEPH ?? '',
        numReg: Branch.agence?.NUMREG ?? '',
        licence: Branch.agence?.LICENCE ?? '',
        numCon: Branch.agence?.NUMCOM ?? '',
        bPoste: Branch.agence?.BPOSTE ?? '',
        ville: Branch.agence?.VILLE ?? '',
        nomUser: user.nomuti ?? '',
        libperiodicite: values.lib_Periodicite ?? values.Periodicite ?? '',
      },
    );
  }

  function modifButton() {
    setSbmit('update');
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle"><b>PROPOSITION MOURABAHA</b></Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          preserve
          autoComplete="off"
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend><Typography color={'darkgreen'}>Actions</Typography></legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size="large" className="bt_add" disabled={modifActve} onClick={modifButton} type="ghost" htmlType="button" block>
                  Modifier
                </Button>
                <Button size="large" className="bt_add" onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Proposer
                </Button>
                <Button size="large" className="bt_add" disabled={impActive} onClick={handleApercu} type="ghost" htmlType="button" block>
                  Aperçu
                </Button>
                <Button size="large" disabled={annulActive} onClick={() => { form.resetFields(); initialiazeButton(); setGarantiesTableau([]); setdatatabamort([]); }} className="bt_add" type="ghost" htmlType="button" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
            <div>
              <Tabs size="small" type="card" defaultActiveKey="1" items={items} />
              <div className='border-left tabElementAuto'>
                <Spin spinning={loading}>
                  <Form disabled={false}>
                    <Table
                      size='small'
                      style={{ width: 'auto' }}
                      rowSelection={{ ...rowSelection, type: 'radio' }}
                      columns={columns}
                      dataSource={data}
                      scroll={{ y: 200, x: 10 }}
                      pagination={false}
                    />
                  </Form>
                </Spin>
              </div>
            </div>
            <div></div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default PropositionMourabaha;
